import { ChangeDetectionStrategy, Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

import { BaseCtrlValueAccessorFormArrayComponent, FormManagerService } from '@sim/form';
import { ClassName } from '@sim/role';

import { cardOA } from '@atmi/core/models';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => IsrFormComponent),
    },
    {
      multi: true,
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => IsrFormComponent),
    },
  ],
  selector: 'app-isr-form',
  styleUrls: ['./isr-form.component.scss'],
  templateUrl: './isr-form.component.html',
})
export class IsrFormComponent extends BaseCtrlValueAccessorFormArrayComponent<cardOA.ISR> implements OnDestroy, OnInit {

  @Input() classNames: ClassName[] = [];

  constructor(
    private readonly formManager: FormManagerService,
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  addHandler() {
    if (!this.form || !this.form.controls) {
      throw new Error('Cannot manage ISR without a control');
    }

    const control = this.formManager.makeForm(cardOA.ISRMeta, {} as cardOA.ISR);
    this.form.push(control);
  }

  removeHandler(index: number) {
    if (!this.form || !this.form.controls) {
      throw new Error('Cannot manage ISR without a control');
    }

    this.form.removeAt(index);
  }

}
